const Loading = () => {
  const styles = {
    color: 'var(--bs-primary)',
    padding: '4rem 2rem 4.5rem',
  }

  return <div style={{ ...styles, position: 'relative', textAlign: 'center' }}><span className="spinner-border spinner-border-sm align-middle me-2"></span><span className="align-middle">Wird geladen... </span></div>
}

export { Loading }